import { render, staticRenderFns } from "./ExecutiveManagement.vue?vue&type=template&id=5d081730&scoped=true"
import script from "./ExecutiveManagement.vue?vue&type=script&lang=js"
export * from "./ExecutiveManagement.vue?vue&type=script&lang=js"
import style0 from "./ExecutiveManagement.vue?vue&type=style&index=0&id=5d081730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d081730",
  null
  
)

export default component.exports